module.exports = __webpack_public_path__ + "static/media/ocean.f0951a35.jpg";